module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6n5n1n-224aead4798715d4d90731530886496e.svg";